import { CSSProperties } from 'react';
import Group from '../Group';
import { Divider, Radio } from 'antd';
import { ApoliceLogo } from '@/core/domain/porto-seguro/apolices/apolices.types';
import moment from 'moment';
import { applyCpfCnpjMask } from '@/utils/mask';

interface Props {
  policy: {
    companyCode: string;
    policyNumber: string;
    finalValidityDate: string;
    customer: {
      birthDate?: string;
      documentNumber?: string;
      contacts?: { email: string; phone: string };
      name: string;
    };
  };
  vehicle: {
    licensePlate: string;
    chassi: string;
    model: string;
    brand: string;
    yearFabrication: number;
    yearModel: number;
  };
  active: boolean;
  style?: CSSProperties;
  onClick: VoidFunction;
}

export default function PortoPolicyCard({
  policy,
  vehicle,
  active,
  style,
  onClick,
}: Props) {
  return (
    <div
      style={style}
      className="workorder-policy-card"
      key={policy.policyNumber}
      data-active={active}
      onClick={onClick}
    >
      <Group gap={16} align="start">
        <Radio checked={active} />
        <div className="policy-content">
          <Group>
            <img src={ApoliceLogo[policy.companyCode]} />

            <Divider type="vertical" />

            <span>
              Vigência: {moment(policy.finalValidityDate).format('DD/MM/YYYY')}
            </span>
          </Group>

          <div>
            <strong>{`${vehicle.licensePlate} • ${vehicle.brand} ${vehicle.model} • ${vehicle.chassi}`}</strong>

            <Group gap={16}>
              <Group gap={4}>
                <span>Fabricação:</span>
                <span>{vehicle.yearFabrication}</span>
              </Group>

              <Group gap={4}>
                <span>Modelo:</span>
                <span>{vehicle.yearModel}</span>
              </Group>
            </Group>

            <div>{policy.customer.name}</div>
            <div>{applyCpfCnpjMask(policy.customer.documentNumber)}</div>
          </div>
        </div>
      </Group>
    </div>
  );
}
